// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 3219, offsets 509879:509929. Structure and names inferred from code, not screenshots.

const recoveredExporty = () => true;
export { recoveredExporty as y };
